module.exports = __webpack_public_path__ + "media/images/projects/1-header-33b0719bfe71ed9b4b5cd0ace77f02b6.jpg";